import React from "react";
import { withRouter, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AccountAside = ({ mode }) => {
    const { t } = useTranslation();

    return (
        <div className="rev-accountaside">
            <div className="rev-tabs-scroll">
                <div className="rev-tabs-scroll__inner">
                    <div className="rev-tabs">
                        <Link to={"/account/basic/home"} className={`rev-tabs__tab ${mode === "basic" ? "is-active" : ""}`}>
                            {t('account.sideNavigation.basic')}
                        </Link>
                        <Link to={"/account/credit/home"} className={`rev-tabs__tab ${(mode === "credit" || mode === "consumptions") ? "is-active" : ""}`}>
                            {t('account.sideNavigation.credit')}
                        </Link>
                        <Link to={"/account/photo-sale/home"} className={`rev-tabs__tab ${mode === "photo-sale" ? "is-active" : ""}`}>
                            {t('Photo Sale')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(AccountAside);
